import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FieldNumberComponent } from './field-number.component';
import { userSettings } from './../../common/settings'
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-field-write',
  template: ``,
})

export class FieldWriteNumberComponent extends FieldNumberComponent implements OnInit {
  @Input() ShowRealVal: boolean = false;
  @Input() MaxVal: number;
  @Input() MinVal: number;
  @Input() Required: boolean = false;
  @Output() TriggerOutsideErrorAnim = new EventEmitter<boolean>();
  @Output() TriggerTextChanged = new EventEmitter<number>();

  //Form
  Form: FormGroup;
  Validator = [];
  FormError: string = "";
  // Animation
  blinkAnimErr: boolean;
  activeAnimErr: boolean;
  // Disable
  Disable: boolean = false;
  backUpVal: number;

  constructor(public fb: FormBuilder, public translateService: TranslateService) {
    super();
    userSettings.halfSecInter.subscribe(x => {
      if (this.activeAnimErr)
        this.blinkAnimErr = x;
    });

    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.checkAndCollectErrors(false);
    });
  }

  ngOnInit() {
    if (!this.MaxLength) {
      this.MaxLength = 0;
      if (this.MaxVal)
        this.MaxLength += this.MaxVal.toString().length;
      if (this.MaxNumsAfterDot)
        if (this.MaxNumsAfterDot > 1)
          this.MaxLength += this.MaxNumsAfterDot + 1;
      if (this.MaxLength == 0) {
        this.MaxLength = 10;
      }
    }
    this.resetValidators(this.Required);
  }

  resetValidators(addReq: boolean = false, value: any = undefined) {
    this.Required = addReq;
    this.Validator = [];
    if (addReq)
      this.Validator.push(Validators.required);
    if (this.MaxVal != undefined)
      this.Validator.push(Validators.max(this.MaxVal));
    if (this.MinVal != undefined)
      this.Validator.push(Validators.min(this.MinVal));
    this.Form = this.fb.group({
      Field: [value, this.Validator],
    });
  }

  onTextChange() {
    // Reset Animation
    this.activeAnimErr = false;
    this.blinkAnimErr = false;
    this.TriggerOutsideErrorAnim.emit(false);

    if (!this.Form)
      return;

    if (!this.checkValValid(this.Form.controls.Field.value)) {
      this.checkAndCollectErrors(false);
      this.TriggerTextChanged.emit(undefined); 
      return;
    }

    let val: string = this.Form.controls.Field.value.toString();
    if (val.length > this.MaxLength) {
      val = val.slice(0, this.MaxLength);
      this.Form.controls.Field.setValue(Number.parseFloat(val));
    }

    if (val.includes('.')) {
      let sec: string = val.split('.')[1];
      if (sec.length > this.MaxNumsAfterDot)
        this.Form.controls.Field.setValue(Number.parseFloat(this.Form.controls.Field.value).toFixed(this.MaxNumsAfterDot));
    }
    this.checkAndCollectErrors(false);

    if (this.FormError != '')
      this.TriggerTextChanged.emit(undefined); 
    else
      this.TriggerTextChanged.emit(Number.parseFloat(this.Form.controls.Field.value));

  }

  getValue(Clear?: boolean): number {
    if (this.Disable)
      return undefined;
    this.checkAndCollectErrors(true);
    // clear field
    if (Clear)
      this.Form.controls.Field.setValue(undefined);
    return this.FormError == "" ? this.Form.controls.Field.value : undefined;
  }

  checkAndCollectErrors(setError: boolean = true) {
    this.FormError = "";
    let val: number = this.Form.controls.Field.value;
    if (!this.checkValValid(val) && this.Required)
      this.FormError += this.translateService.instant('VALIDATIONS.EMPTY') + "\n";
    if (this.checkValValid(val)) {
      if (val.toString().length > this.MaxLength)
        this.FormError += this.translateService.instant('VALIDATIONS.MAXLENGTH') + "\n";
      if (this.MaxVal != undefined)
        if (val > this.MaxVal)
          this.FormError += this.translateService.instant('VALIDATIONS.MAXVAL') + "\n";
      if (this.MinVal != undefined)
        if (val < this.MinVal)
          this.FormError += this.translateService.instant('VALIDATIONS.MINVAL') + "\n";
    }
    if (setError && this.FormError != "")
      this.setError();
  }

  checkValValid(val: any): boolean {
    if (val == null)
      return false;
    if (val == undefined)
      return false;

    return true;
  }

  setError(force: boolean = true) {
    if (force)
      this.Form.controls['Field'].setErrors({ 'incorrect': true });
    this.activeAnimErr = true;
    this.TriggerOutsideErrorAnim.emit(true);
  }

  disable() {
    this.backUpVal = this.Form.controls.Field.value;
    this.Form.controls.Field.setValue('');
    this.Form.disable();
    this.Disable = true;
    // Reset Animation
    this.activeAnimErr = false;
    this.blinkAnimErr = false;
  }

  enable() {
    this.Form.enable();
    this.Form.controls.Field.setValue(this.backUpVal);
    this.Disable = false;
    // Reset Animation
    this.activeAnimErr = false;
    this.blinkAnimErr = false;
  }
}